// extracted by mini-css-extract-plugin
export var active = "_gl-7";
export var blink = "_gl-8";
export var dropDownSelector = "_gl-4";
export var dropDownWrapper = "_gl-3";
export var fakeCursor = "_gl-6";
export var fontSizeButton = "_gl-9";
export var formQuillEditor = "_gl-0";
export var pressed = "_gl-a";
export var qlBlank = "_gl-1";
export var textFormattingToolbar = "_gl-2";
export var textToolbarOption = "_gl-5";